import React from 'react'
import FileCountBadge from './FileCountBadge'

class FileCountBadgeContainer extends React.PureComponent {
  constructor (props, context) {
    super(props, context)
    this.state = {isTooltipOpen: false, uid: `FileCountBadgeContainer${Date.now()}`}
  }

  toggle = () => {
    this.setState({isTooltipOpen: !this.state.isTooltipOpen})
  }

  componentDidMount () {
  }

  render () {
    const methods = {
      toggle: this.toggle
    }
    return <FileCountBadge {...methods} {...this.props} {...this.state} />
  }
}

FileCountBadgeContainer.propTypes = {}

export default FileCountBadgeContainer



// WEBPACK FOOTER //
// ./src/components/FileCountBadge/FileCountBadgeContainer.js